<template>
  <footer class="pl-6 pr-6 pb-6"><!-- update 230412 - p-6 -->
    <slot />
  </footer>
</template>
